/*
  COMPONENT: CelloArtists
  PURPOSE: Gets Cello artists for category display
*/
import React from 'react'

// components
import CategoryArtists from './CategoryArtists'

// hooks
import useAllArtistsCello from '../hooks/use-all-artists-cello'

// view
const CelloArtists = () => {
  const artists = useAllArtistsCello()

  return <CategoryArtists artists={artists} category="Cello" />
}

export default CelloArtists
